(function () {
  'use strict';

  // Mersalg-kortet i handlekurv-skuffen.
  // Regel: vis kortet så lenge handlekurven har varer og tilbudsproduktet
  // ikke allerede ligger der – med mindre kunden har krysset det vekk
  // (gjelder ut nettleserøkten) eller trykket «Legg til».
  // Kortet får data-cart-count og data-in-cart fra Liquid ved hver
  // re-rendering av skuffen, så vi trenger ikke spørre /cart.js.

  const DISMISSED_KEY = 'cart_upsell_dismissed';

  function isDismissed() {
    try { return sessionStorage.getItem(DISMISSED_KEY) === '1'; } catch (e) { return false; }
  }

  function setDismissed() {
    try { sessionStorage.setItem(DISMISSED_KEY, '1'); } catch (e) { /* ignorer */ }
  }

  function getCard() {
    return document.getElementById('cart-upsell-card');
  }

  function sync() {
    const card = getCard();
    if (!card) return;

    const count = parseInt(card.dataset.cartCount || '0', 10);
    const inCart = card.dataset.inCart === '1';
    const shouldShow = count > 0 && !inCart && !isDismissed();

    if (shouldShow) {
      card.removeAttribute('hidden');
      bindCloseButton(card);
      bindAddButton(card);
    } else {
      card.setAttribute('hidden', '');
    }
  }

  function bindCloseButton(card) {
    const btn = card.querySelector('[data-cart-upsell-close]');
    if (!btn || btn._bound) return;
    btn._bound = true;
    btn.addEventListener('click', () => {
      setDismissed();
      card.setAttribute('hidden', '');
    });
  }

  function bindAddButton(card) {
    const btn = card.querySelector('[data-cart-upsell-add]');
    if (!btn || btn._bound) return;
    btn._bound = true;

    btn.addEventListener('click', async () => {
      const variantId = card.dataset.variantId;
      const btnText = btn.querySelector('.cart-upsell-card__btn-text');
      const spinner = btn.querySelector('.cart-upsell-card__spinner');
      btn.disabled = true;
      if (btnText) btnText.hidden = true;
      if (spinner) spinner.hidden = false;

      try {
        const addRes = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 }),
        });
        if (!addRes.ok) throw new Error();

        // Hent oppdatert drawer-HTML og oppdater uten sidereload.
        // Den nye HTML-en har data-in-cart="1", så sync() skjuler kortet.
        const sectionsRes = await fetch('/?sections=cart-drawer,cart-icon-bubble');
        if (sectionsRes.ok) {
          const sections = await sectionsRes.json();
          const drawerEl = document.querySelector('cart-drawer');
          if (drawerEl) {
            drawerEl.renderContents({ sections, id: variantId });
          }
        }
      } catch (e) {
        btn.disabled = false;
        if (btnText) btnText.hidden = false;
        if (spinner) spinner.hidden = true;
      }
    });
  }

  // Skuffen re-rendres på flere måter (legg til, endre antall, fjern,
  // Swym osv.) og erstatter da hele innholdet, inkludert kortet.
  // En MutationObserver fanger alle variantene uten å patche temaets JS.
  function observe() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    let scheduled = false;
    const observer = new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        sync();
      });
    });
    observer.observe(drawer, { childList: true, subtree: true });
  }

  function init() {
    sync();
    observe();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
